var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconWarningSolid = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    height = 24,
    titleId,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.895 1.71c.269.167.485.406.625.69l8.88 18.092a1.425 1.425 0 0 1-1.28 2.055H2.88a1.425 1.425 0 0 1-1.28-2.055L10.48 2.4a1.693 1.693 0 0 1 2.415-.69M12 7.733a.75.75 0 0 1 .75.75v7.032a.75.75 0 0 1-1.5 0V8.484a.75.75 0 0 1 .75-.75m-.779 10.167a1.101 1.101 0 1 1 1.558 1.557 1.101 1.101 0 0 1-1.558-1.557",
    clipRule: "evenodd"
  })));
});
export const Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 24,
    titleId,
    title,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.895 1.71c.269.167.485.406.625.69l8.88 18.092a1.425 1.425 0 0 1-1.28 2.055H2.88a1.425 1.425 0 0 1-1.28-2.055L10.48 2.4a1.693 1.693 0 0 1 2.415-.69M12 7.733a.75.75 0 0 1 .75.75v7.032a.75.75 0 0 1-1.5 0V8.484a.75.75 0 0 1 .75-.75m-.779 10.167a1.101 1.101 0 1 1 1.558 1.557 1.101 1.101 0 0 1-1.558-1.557",
    clipRule: "evenodd"
  })));
});
export default SvgIconWarningSolid;
export const raw = __webpack_public_path__ + "static/media/IconWarningSolid.d199b052aa6460d856bf6b7977780461.svg";